module.exports = __webpack_public_path__ + "img/商品详情1-2.db3ef585.png";